<template>
  <v-navigation-drawer
    permanent
    app
    dark
    color="var(--primary-color)"
    class="nav-drawer"
  >
    <v-list nav dense class="pt-4 pb-4">

      <template v-for="(item, index) in menuItems">

        <!-- SIMPLE ITEM -->
        <v-list-item
          v-if="item.children.length < 1 && hasAccess(item)"
          :key="index"
          :to="'/home/' + item.to"
          class="nav-item"
        >
          <v-list-item-icon>
            <v-icon class="nav-icon">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-title class="nav-title">
            {{ getTitle(item) }}
          </v-list-item-title>
        </v-list-item>

        <!-- GROUP ITEM -->
        <v-list-group
          v-else-if="item.children.length > 0 && hasAccess(item)"
          :key="'g-' + index"
          v-model="menu[item.id]"
          no-action
          class="nav-group"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon class="nav-icon">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title class="nav-title">
              {{ getTitle(item) }}
            </v-list-item-title>

            <v-icon class="chevron">
              {{ menu[item.id] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
          </template>

          <!-- CHILDREN -->
          <template v-for="(child, cIndex) in item.children">

            <!-- CHILD -->
            <v-list-item
              v-if="child.children.length < 1 && hasAccess(child)"
              :key="'c-' + cIndex"
              :to="'/home/' + child.to"
              class="nav-sub-item"
            >
              <v-list-item-icon>
                <v-icon class="nav-icon">{{ child.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-title class="nav-title">
                {{ getTitle(child) }}
              </v-list-item-title>
            </v-list-item>

            <!-- GRAND CHILD -->
            <v-list-group
              v-else-if="child.children.length > 0 && hasAccess(child)"
              :key="'cg-' + cIndex"
              no-action
              sub-group
              v-model="menu[child.id]"
              class="nav-group-sub"
            >
              <template v-slot:activator>
                <v-list-item-title class="nav-title">
                  {{ getTitle(child) }}
                </v-list-item-title>
              </template>

              <v-list-item
                v-for="(last, lIndex) in child.children"
                :key="'l-' + lIndex"
                :to="'/home/' + last.to"
                class="nav-sub-sub-item"
              >
                <v-list-item-icon>
                  <v-icon class="nav-icon">{{ last.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-title class="nav-title">
                  {{ getTitle(last) }}
                </v-list-item-title>
              </v-list-item>

            </v-list-group>

          </template>
        </v-list-group>

      </template>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "NavigationDrawer",

  data() {
    return {
      menuItems: [],
      menu: {}
    };
  },

  mounted() {
    this.menuItems = this.buildMenu();
  },

  methods: {

    buildMenu() {
      const roles = ["SuperAdmin", "Admin", "Administrator", "Unassigned", "AksaAdmin", "BgaMaster", "YkYonetim", "OnaysizIcerik", "OnayliIcerik", "Subscriber", "Contributor", "Author", "Editor", "Administrator"];

      return [
        {
          id: 'adminList',
          icon: 'mdi-account-star-outline',
          to: 'admin-list',
          children: [],
          roles
        },
        {
          id: 'categories',
          icon: 'mdi-shape',
          to: 'categories',
          children: [],
          roles
        },
        {
          id: 'emergency',
          icon: 'mdi-alert',
          to: 'emergency',
          children: [],
          roles
        },
        {
          id: 'posts',
          icon: 'mdi-post',
          to: 'moduls/kurumsal_haberler',
          children: [],
          roles
        },
        {
          id: 'notifications',
          icon: 'mdi-bell-ring',
          to: 'notifications',
          children: [],
          roles
        },
        {
          id: 'foodMenus',
          icon: 'mdi-food',
          to: 'food-menus',
          children: [],
          roles
        },

        {
          id: 'surveys',
          icon: 'mdi-poll',
          to: 'moduls/surveys',
          children: [],
          roles
        },
        
        {
          id: 'newcomers',
          icon: 'mdi-account',
          to: 'moduls/newcomers',
          children: [],
          roles
        },

        {
          id: 'careerOpportunities',
          icon: 'mdi-briefcase-search',
          to: 'moduls/kariyer_firsatlari',
          children: [],
          roles
        },
        {
          id: 'corporatePublications',
          icon: 'mdi-book-open-page-variant',
          to: 'moduls/corporate_publications',
          children: [],
          roles
        },

        {
          id: 'stories',
          icon: 'mdi-circle-slice-8',
          to: 'stories',
          children: [],
          roles
        },

        /* YÖNETİM KURULU */

         {
          id: 'boardMeetings',
          icon: 'mdi-domain',
          to: 'moduls/board_meetings',
          children: [],
          roles
        },
        {
          id: 'boardResolutions',
          icon: 'mdi-file-sign',
          to: 'moduls/board_resolutions',
          children: [],
          roles
        },
        {
          id: 'committeePresentations',
          icon: 'mdi-monitor',
          to: 'moduls/committee_presentations',
          children: [],
          roles
        },
        {
          id: 'materialEventDisclosures',
          icon: 'mdi-information-outline',
          to: 'moduls/material_event_disclosures',
          children: [],
          roles
        },
        {
          id: 'keyFinancialIndicators',
          icon: 'mdi-finance',
          to: 'moduls/key_financial_indicators',
          children: [],
          roles
        },
        {
          id: 'financialStatements',
          icon: 'mdi-receipt-text-outline',
          to: 'moduls/financial_statements',
          children: [],
          roles
        },
        {
          id: 'otherDocuments',
          icon: 'mdi-folder-open-outline',
          to: 'moduls/other_documents',
          children: [],
          roles
        },

        /* YÖNETİM KURULU */
        {
          id: 'listings',
          icon: 'mdi-shopping',
          to: 'listings',
          children: [],
          roles
        },
        {
          id: 'qrManagement',
          icon: 'mdi-qrcode-scan',
          to: 'qr-management',
          children: [],
          roles
        },
        {
          id: 'meetingNotes',
          icon: 'mdi-note-text',
          to: 'moduls/meeting_notes',
          children: [],
          roles
        },
        {
          id: 'committee',
          icon: 'mdi-account-supervisor',
          to: 'moduls/committee',
          children: [],
          roles
        },
        {
          id: 'committeeElections',
          icon: 'mdi-account-group',
          to: 'committee-elections',
          children: [],
          roles
        },
        {
          id: 'faqEmployee',
          icon: 'mdi-account-question',
          to: 'moduls/faq_employee',
          children: [],
          roles
        },
        {
          id: 'faqManager',
          icon: 'mdi-account-tie',
          to: 'moduls/faq_manager',
          children: [],
          roles
        },
        {
          id: 'dealsDiscounts',
          icon: 'mdi-sale',
          to: 'moduls/deals_discounts',
          children: [],
          roles
        },
        {
          id: 'documents',
          icon: 'mdi-file-document-multiple',
          to: 'moduls/documents',
          children: [],
          roles
        },
        {
          id: 'dictionary',
          icon: 'mdi-sort-alphabetical-ascending',
          to: 'moduls/dictionary',
          children: [],
          roles
        },
        {
          id: 'emergencyPlan',
          icon: 'mdi-alert',
          to: 'moduls/emergency_plan',
          children: [],
          roles
        },
        {
          id: 'contacts',
          icon: 'mdi-contacts',
          to: 'moduls/contacts',
          children: [],
          roles
        },
        {
          id: 'sharedContacts',
          icon: 'mdi-folder-account',
          to: 'moduls/shared_contacts',
          children: [],
          roles
        },
        {
          id: 'importantContacts',
          icon: 'mdi-car-brake-alert',
          to: 'moduls/important_contacts',
          children: [],
          roles
        },
      ];
    },

    hasAccess(item) {
      const role = this.$store.state.Type;
      if (!item.roles || item.roles.length === 0) return true;
      return item.roles.includes(role);
    },

    getTitle(item) {
      return item.title
        ? item.title
        : this.$t('navigationDrawerMenu.' + item.id);
    }
  }
};
</script>

<style scoped>
/* ITEM BASE */
.nav-item,
.nav-sub-item,
.nav-sub-sub-item {
  border-radius: 8px;
  margin: 2px 6px;
  transition: 0.2s;
}

.nav-item:hover,
.nav-sub-item:hover,
.nav-sub-sub-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

/* ICON */
.nav-icon {
  font-size: 22px;
}

/* TEXT */
.nav-title {
  font-size: 14px;
  color: #fff;
}

/* CHEVRON */
.chevron {
  color: #fcd06e;
}
</style>